<div class="form-check">
  <input
    type="checkbox"
    class="form-check-input"
    [formControlName]="controlName"
    id="checkbox-{{ controlName }}"
    [required]="required"
    [attr.aria-invalid]="hasErrors()"
    [attr.aria-required]="required"
    [attr.aria-describedby]="hasErrors() ? 'error-label-' + controlName : null"
    />
  <label class="form-check-label" for="checkbox-{{ controlName }}">
    {{ label }}
    @if (required) {
      &nbsp;*
    }
  </label>
</div>


<!-- Validierungs­-Feedback -->
@if (hasErrors()) {
  <pf-validation-message
    [name]="controlName"
    [validationMessages]="getRelevantErrorMessage()"
    id="error-{{ controlName }}"
  ></pf-validation-message>
}
